<div class="ui padded segment">
  <div class="ui header">
    <div class="sub header">Hosted</div>
  </div>
  <div class="ui horizontal list">
    <div class="item">
      <img
        class="ui mini circular image"
        src="{{ (userInfo$ | async)?.photoURL }}"
      />
      <div class="content">
        {{ (userInfo$ | async)?.displayName }}
        <div class="ui sub header grey text">
          <span *ngIf="(userInfo$ | async)?.city"
            >{{ (userInfo$ | async)?.city }},</span
          >
          <span *ngIf="(userInfo$ | async)?.country">{{
            (userInfo$ | async)?.country
          }}</span>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="(userInfo$ | async)?.superhost">
    <div role="list" class="ui grey text list">
      <div role="listitem" class="item">
        <i class="map marker alternate icon"></i>
        <div class="content grey text">
          PVR: Treasure Island Mall, indore , Madhya pradesh
        </div>
      </div>
      <div role="listitem" class="item">
        <i class="globe icon"></i>
        <div class="content grey text">www.signgaze.com</div>
      </div>
    </div>
    <div class="ui basic fitted horizontally">
      <button class="ui rounded icon small basic button">
        <i class="facebook icon"></i>
      </button>
      <button class="ui rounded icon small basic button">
        <i class="twitter icon"></i>
      </button>
      <button class="ui rounded icon small basic button">
        <i class="google plus icon"></i>
      </button>
    </div>
  </ng-container>
</div>
